<template>
<div class="supplier-popup">
	<div class="popup" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Поставщик «{{ supplier?.legalForm?.name }} {{ supplier?.companyName }}»</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="info-list">
					<SupplierInfo :supplier="supplier"/>
					<template v-if="canEdit">
						<div class="info-list__item">
							<div class="info-list__title info-list__title--inline page-subtitle">Представители
								<div class="tooltip">
									<span class="tooltip__icon"></span>
									<span class="tooltip__text">Позволяет добавить дополнительный аккаунт для представителя компании</span>
								</div>
							</div>
							<div class="info-list__representatives">
								<div class="representatives">
									<div class="representatives__lis tags-list">
										<div class="representatives__item tags-list__item" v-for="representatives in supplier?.representatives" :key="representatives"> {{ representatives.email }} </div>
									</div>
									<div class="representatives__add btn btn--border" @click="ShowAddRepresentativePopup = true">Добавить представителя</div>
								</div>
							</div>
						</div>						
						<div class="info-list__item">
							<div class="info-list__title page-subtitle">Данные для входа</div>
							<div class="info-list__wrap">
								<InputText :label="'Логин'" :placeholder="supplier?.email" :readonly="true"/>
								<div class="default-input">
									<div class="default-input__label">Пароль</div>
									<button class="btn btn--border" @click.prevent="sendPassword">Отправить пароль</button>
									<div v-if="passSentDate || supplier.passSent" class="default-input__label default-input__label--bottom">Ранее направлен: {{ passSentDate || supplier.passSent }}</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
			<hr>
			<div class="popup__btns" v-if="canEdit" >
				<button v-if="supplier.status?.code === 'new'" class="btn btn--color" @click="ShowAgreementApprovePopup = true">На согласовании</button>
				<button v-if="supplier.status?.code === 'in_progress'" class="btn btn--color" @click="ShowSignContractPopup = true">Договор подписан</button>
				<button class="btn btn--border" @click="ShowEditSupplierPopup = true">Редактировать</button>
				<button v-if="['administrator', 'manager'].includes(getUserRole)" @click="ShowAddBlackListPopup = true" class="btn btn--border btn--cancel">Добавить в черный список</button>
			</div>
		</div>
		<PageLoader v-if="isLoading"/>

	</div>
	<transition-group name="modal">
		<EditSupplierPopup v-if="ShowEditSupplierPopup" :supplier="supplier"  @refreshList="refreshList" @close="ShowEditSupplierPopup = false"/>
		<AddBlackListPopup v-if="ShowAddBlackListPopup" :supplier="supplier" @refreshList="refreshList" @close="ShowAddBlackListPopup = false"/>
		<SignContractPopup v-if="ShowSignContractPopup" :supplier="supplier" @refreshList="refreshList" @close="ShowSignContractPopup = false"/>
		<AgreementApprovePopup v-if="ShowAgreementApprovePopup" :supplier="supplier" @refreshList="refreshList" @close="ShowAgreementApprovePopup = false"/>
		<AddRepresentativePopup v-if="ShowAddRepresentativePopup" :supplier="supplier" @refreshList="refreshList" @close="ShowAddRepresentativePopup = false"/>
	</transition-group>
</div>
</template>

<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import EditSupplierPopup from "@/components/sections/Suppliers/EditSupplierPopup.vue";
import AddBlackListPopup from "@/components/sections/Suppliers/AddBlackListPopup.vue";
import SignContractPopup from "@/components/sections/Suppliers/SignContractPopup.vue";
import AgreementApprovePopup from "@/components/sections/Suppliers/AgreementApprovePopup.vue";
import AddRepresentativePopup from "@/components/sections/Suppliers/AddRepresentativePopup.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import Fetch from "@/utils/Fetch";
import {useToast} from "vue-toastification";
import SupplierInfo from '@/components/sections/Suppliers/SupplierInfo.vue';
import { mapGetters } from "vuex";


export default {
	name: "SupplierPopup",
	components: {InputText,AddBlackListPopup, EditSupplierPopup,PageLoader, SignContractPopup, AgreementApprovePopup,SupplierInfo, AddRepresentativePopup},
	emits: ["refreshList", "close"],
	props: {
		supplier: {
			type: Object,
			default: () => {}
		},
		canEdit: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			ShowAddBlackListPopup: false,
			ShowEditSupplierPopup: false,
			ShowSignContractPopup: false,
			ShowAgreementApprovePopup: false,
			ShowAddRepresentativePopup: false,
			toast: useToast(),
			isLoading: false,
			passSentDate: ''
		}
	},
	methods: {
		refreshList() {
			this.$emit('close')
			this.$emit('refreshList')
		},
		async sendPassword() {
			this.isLoading = true
			let response = await Fetch(`suppliers/password/send/${this.supplier.id}/`, {
				method: 'POST',
			})

			if(response.success) {
				this.toast.success(`Пароль успешно отправлен`);
				this.passSentDate = response.data
			} else {
				this.toast.error(response.message);
			}
			this.isLoading = false
		},
	},
	computed: {
		...mapGetters({
			getUserRole: 'user/getUserRole',
		})
	}
}
</script>


